import { ElMessage } from 'element-plus'

export function UseMessage(message,type,duration=1000) {
  ElMessage.closeAll()
  ElMessage({
    message,
    type,
    duration 
  })
}